import moment from 'moment';
import { useSelector } from 'react-redux';
import { Grid, Tooltip, makeStyles } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, Typography } from 'components';

const useStyles = makeStyles((theme) => ({
  grid: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    alignItems: 'center',
  },
  chipAssembly: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 18,
    gap: 4,
    borderRadius: 24,
    padding: '0 4px',
    marginLeft: 6,
    backgroundColor: 'rgba(1, 197, 138, 0.12)',
  },
  chipEdited: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 18,
    borderRadius: 24,
    padding: '0 4px',
    marginLeft: 6,
    backgroundColor: 'rgba(0, 115, 209, 0.12)',
  },
  chipConsul: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 18,
    borderRadius: 24,
    padding: '0 8px',
    backgroundColor: '#FFEFCE',
  },
}));

const AttendanceRowItem = ({
  data,
  account,
  onDeleteClick = null,
  onRebridgeClick = null,
  onViewDetailClick = null,
  onEditClick = null,
}) => {
  const classes = useStyles();
  const { env } = useSelector((state) => state.app);

  const consoleAttendanceDocsId = (attendanceId) => {
    if (account.isDeveloper) {
      console.log(attendanceId);
    }
  };

  const isLate = (shiftStartTime, entryTime) => {
    if (env.projectId === 'atmost-tripat') {
      const tolerance = moment(shiftStartTime).add(15, 'minutes');
      return moment(entryTime).diff(tolerance, 'minute') > 0;
    } else {
      return moment(entryTime).diff(shiftStartTime, 'minute') > 0;
    }
  };

  return (
    <Grid container style={{ paddingLeft: 4 }}>
      <Grid item xs={3} className={classes.grid}>
        <Typography
          style={{ cursor: account.isDeveloper ? 'pointer' : 'default' }}
          onClick={() => consoleAttendanceDocsId(data.attendanceId)}
          variant="body1"
        >
          {moment(data.entryTime).format('DD/MM/YYYY')}
        </Typography>
        {data.isAttendMorningAssembly && (
          <Tooltip title={'Mengikuti Apel Pagi'} arrow placement="top">
            <div className={classes.chipAssembly}>
              <FontAwesomeIcon icon="user-check" size="1x" color="green" style={{ width: 10 }} />
              <Typography variant="caption" color="green">
                Apel Pagi
              </Typography>
            </div>
          </Tooltip>
        )}
      </Grid>
      <Grid item xs={3} className={classes.grid}>
        <Typography variant="body1">
          {data.entryTime ? moment(data.entryTime).format('DD/MM/YYYY') : '-'}
        </Typography>
        {!!data.shiftStartTime && isLate(data.shiftStartTime, data.entryTime) ? (
          <Typography variant="body1" type="bold" color="#EF4040" style={{ marginLeft: 4 }}>
            {data.entryTime ? moment(data.entryTime).format('HH:mm') : ''}
          </Typography>
        ) : (
          <Typography variant="body1" style={{ marginLeft: 4 }}>
            {data.entryTime ? moment(data.entryTime).format('HH:mm') : ''}
          </Typography>
        )}
        {data.isEntryEdit && (
          <Tooltip
            title={
              data.entryTimePrev ? moment(data.entryTimePrev).format('DD/MM/YYYY HH:mm') : '...'
            }
            arrow
            placement="top"
          >
            <div className={classes.chipEdited}>
              <Typography variant="caption" color="#0073D1">
                Edited
              </Typography>
            </div>
          </Tooltip>
        )}
      </Grid>
      <Grid item xs={3} className={classes.grid}>
        <Typography variant="body1">
          {data.exitTime ? moment(data.exitTime).format('DD/MM/YYYY HH:mm') : '-'}
        </Typography>
        {data.isExitEdit && (
          <Tooltip
            title={data.exitTimePrev ? moment(data.exitTimePrev).format('DD/MM/YYYY HH:mm') : '...'}
            arrow
            placement="top"
          >
            <div className={classes.chipEdited}>
              <Typography variant="caption" color="#0073D1">
                Edited
              </Typography>
            </div>
          </Tooltip>
        )}
      </Grid>
      <Grid item xs={2} style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ marginLeft: 16 }}>
          <Grid style={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="body1" color="#8DA1AB">
              {data.employeeNo}
            </Typography>
            {data.isConsul && (
              <div className={classes.chipConsul}>
                <Typography variant="caption" color="#FBB327">
                  Konsul
                </Typography>
              </div>
            )}
          </Grid>
        </div>
      </Grid>
      <Grid
        item
        xs={1}
        className={classes.grid}
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Tooltip placement="top" title="Lihat detail kehadiran" arrow>
          <IconButton
            icon="eye"
            color="#A5B3BA"
            style={{ marginRight: 8 }}
            onClick={onViewDetailClick}
          />
        </Tooltip>
        {onEditClick && (
          <Tooltip placement="top" title="Ubah data kehadiran" arrow>
            <IconButton
              icon="edit"
              color="#A5B3BA"
              style={{ marginRight: 8 }}
              onClick={onEditClick}
            />
          </Tooltip>
        )}
        <Tooltip placement="top" title="Hapus data kehadiran" arrow>
          <IconButton
            icon="trash"
            color="#A5B3BA"
            style={{ marginRight: 8 }}
            onClick={onDeleteClick}
          />
        </Tooltip>
        <Tooltip placement="top" title="Bridging Ulang kehadiran ini" arrow>
          <IconButton icon="sync" color="#A5B3BA" onClick={onRebridgeClick} />
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default AttendanceRowItem;
